import { createSignal } from "solid-js";

// Whether the current session is browsing with its platform-scope reach deliberately removed.
// The backend masks the Root and Admin bits while it is on, so nothing else in the UI needs to
// know: this signal exists only so the banner can render and offer the way back out.
//
// The mode itself lives in a cookie the server reads per request, and /api/User reports the state
// on every load, which is what keeps the banner honest. This copy is a paint hint: without it the
// banner is absent until that request resolves, so a reload flashes the full admin view before
// correcting itself. The server response always wins and writes through, so an expired cookie
// clears the hint rather than leaving a banner claiming a mode that has ended.
const STORAGE_KEY = "vektor.viewAsMember";

function readHint(): boolean {
    try {
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
}

const [viewingAsMember, setViewingAsMemberSignal] = createSignal(readHint());

export const memberView = viewingAsMember;

export function setViewingAsMember(next: boolean) {
    const on = next === true;
    setViewingAsMemberSignal(on);
    try {
        if (on) localStorage.setItem(STORAGE_KEY, "1");
        else localStorage.removeItem(STORAGE_KEY);
    } catch {
        // Private-mode or blocked storage: the mode still works, the banner just paints a tick late.
    }
}
